import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import {HeaderView as CommonHeaderView} from 'components/shell/header/styled'

const getBackgroundColor = props => props.theme.shell.header.color
const getBorder = props => props.theme.shell.header.border || {}
const getBorderWidth = props => getBorder(props).width
const getBorderColor = props => getBorder(props).color
const getBorderStyle = props => getBorder(props).style
const getMobileImageSize = props => (props.isProfile ? '225% 100%' : '150% 150%')
const getTabletImageSize = props => (props.isProfile ? '130% 100%' : '100% auto')

const HeaderView = styled(CommonHeaderView)`
  background-color: ${getBackgroundColor};
  border-width: ${getBorderWidth};
  border-color: ${getBorderColor};
  border-style: ${getBorderStyle};
  background-image: url('/assets/schlager-header-profile-mobile.png');
  background-position: left top;
  background-size: ${getMobileImageSize};

  ${breakpoint('mobile')`
    background-size: ${getTabletImageSize};
  `};

  ${breakpoint('portrait')`
    background-image: url('/assets/schlager-header-desktop.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  `};
`

export default HeaderView
